import { Body1, Title, Title2 } from 'components/Typography';
import { useRouter } from 'next/navigation';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const router = useRouter();
  const { t } = useTranslation('common');
  return (
    <>
      <div className='flex flex-col items-center justify-center'>
        <Title className='text-xl font-bold text-white md:text-[52px] md:leading-[62px]'>
          404
        </Title>
        <Body1 className='mb-3 mt-2 text-xs font-light leading-6 text-white md:mb-4 md:mt-3 md:text-[1.25rem]'>
          {t('OOPS_PAGE_NOT_FOUND')}
        </Body1>
        <button
          onClick={() => router.push('/')}
          className='mb-2.5 rounded-full border-[0.4px] border-mono-100 bg-[linear-gradient(102.69deg,_#151518_0%,_#0E0E13_100%)] px-3 py-1 hover:border-[0.2px] hover:bg-[linear-gradient(103deg,_#363636_0%,_#1A1A1A_100%)] md:px-8 md:py-4'
        >
          <Title2 className='font-normal leading-4 text-white md:leading-6'>
            {t('BACK_TO_HOMEPAGE')}
          </Title2>
        </button>
      </div>
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default NotFound;
